import { Magnitude } from '@upright/common/model/company-client-data/types';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useCarouselContext, useImpactBarsLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { InsightsLensData } from '@upright/ui/common/upright/core/impact-lenses/insights/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import styled from 'styled-components';

interface Props {
  impact: ImpactCategoryId;
  valence: Valence;
}

/**
 * Data label drawn inside the bar if the bar is long enough to have space for it
 */
export function InsightBarDataLabel(props: Props) {
  const context = useCarouselContext<ImpactLensType.INSIGHTS>();
  const layout = useImpactBarsLayout();

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const data = context?.data as InsightsLensData;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!data) {
    return <></>;
  }
  const insights = data.insights;
  if (!insights) {
    return <></>;
  }
  const barArea = layout.impactBarArea(valenceToSide(props.valence), props.impact);

  if (barArea.width < 35) {
    return <></>;
  }

  const item = insights.find(d => d.impactCategoryId === props.impact && d.valence === props.valence);
  if (!item) {
    return <></>;
  }

  function getText(m: Magnitude) {
    if (!m) {
      return '';
    }
    switch (m) {
      case Magnitude.MAJOR:
        return 'major';
      case Magnitude.MEDIUM:
        return 'medium';
      case Magnitude.MINOR:
        return 'minor';
      default:
        return '';
    }
  }

  const x = barArea.cx;
  const anchor = 'middle';

  // const margin = 2;
  // const x = props.valence === Valence.POSITIVE ? barArea.x1 + margin : barArea.x2 - margin;
  // const anchor = props.valence === Valence.POSITIVE ? 'start' : 'end';

  const color = props.valence === Valence.POSITIVE ? BouColor.TOOL_TEXT_BLACK : BouColor.TOOL_TEXT_WHITE;
  return (
    <Text fill={color} x={x} textAnchor={anchor} y={barArea.cy} dy="0.35em">
      {getText(item.magnitude)}
    </Text>
  );
}

const Text = styled.text`
  text-transform: uppercase;
  font-size: 8px;
  /*fill: ${BouColor.TOOL_TEXT_DARK_GRAY};*/
`;
